import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAlertConfirmStore from 'zustands/useAlertConfirmStore';

import useLoadingStore from 'zustands/useLoadingStore';
import { AxiosResponse } from 'axios';
import useApi from 'hooks/useApi';
import useErrorLog from 'hooks/useErrorLog';

// id 는 base64 라 '+' 를 포함할 수 있다. URLSearchParams 는 '+' 를 공백으로 디코딩하므로
// 원본 쿼리 문자열에서 직접 꺼낸다. (미인코딩 링크의 '+' 와 인코딩 링크의 '%2B' 둘 다 지원)
const getRawQueryValue = (search: string, key: string) => {
  const prefix = `${key}=`;
  const raw =
    search
      .replace(/^\?/, '')
      .split('&')
      .find((param) => param.startsWith(prefix))
      ?.slice(prefix.length) ?? '';

  if (!raw.includes('%')) return raw;

  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
};

const PaystubEmployeeLogin = () => {
  const { search } = useLocation();
  const id = getRawQueryValue(search, 'i');

  const [memberBirth, setMemberBirth] = useState('');
  const navigate = useNavigate();

  const { setLoadingState } = useLoadingStore();
  const { setModalState } = useAlertConfirmStore();

  const { webApiNode } = useApi();
  const { checkErrorLog } = useErrorLog();

  const getPaystubCheckDate = async () => {
    if (!memberBirth.trim()) {
      setModalState({
        isModalShow: true,
        title: '인증 실패',
        desc: '정확한 생년월일을 입력해주세요',
      });
      return;
    }
    try {
      setLoadingState({ isFetchLoading: true });
      const { data }: AxiosResponse['data'] = await webApiNode('post', `/paystub/getPaystubCheckDate`, {
        id,
        BIRTHDATE: memberBirth,
      });

      if (data.message === 'SUCCESS') {
        navigate(`/paystub-employee-preview?id=${encodeURIComponent(id)}`);
      } else {
        setModalState({
          isModalShow: true,
          title: '인증 실패',
          desc: data.resultMsg || '인증 실패',
        });
      }
    } catch (err) {
      checkErrorLog(err, 'paystub/getPaystubCheckDate');
    } finally {
      setLoadingState({ isFetchLoading: false });
    }
  };
  return (
    <div className="flex w-full flex-1 flex-col items-center justify-center bg-white">
      <div className="flex flex-col justify-center">
        <strong className="text-center font-['Jua'] text-[3.6rem] text-[#bc1a21]">급여명세서</strong>
        <span className="text-center text-[1.3rem]">샵솔</span>
        <div className="flex justify-center py-[15%]">
          <img src={require('assets/images/authMember.png')} alt="authMember Image" className="h-auto w-[240px]" />
        </div>
      </div>
      <div className="mt-[3%]">
        <div className="text-[1.05rem] font-bold">급여명세서 조회하기</div>
        <div>
          <input
            type="text"
            pattern="[0-9]*"
            maxLength={8}
            className="my-[10px] w-[200px] rounded-[5px] border border-[#BBBBBB] p-[10px_5px] text-center placeholder:text-[0.9rem] placeholder:text-[#aaa]"
            value={memberBirth}
            onChange={(e) => setMemberBirth(e.target.value)}
            placeholder="생년월일 8자리 (ex. 19900101)"
          />
        </div>
        <div className="flex">
          <button
            onClick={() => {
              getPaystubCheckDate();
            }}
            className="w-full rounded-[5px] bg-[#218E8E] p-[10px_0] text-white">
            조회하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaystubEmployeeLogin;
